<template>
  <div class="__table-inativacao-lote-preview">
    <page-tabs :tabs="tabs" />
    <div class="wrapper-table table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Empresa / CNPJ</th>
            <th scope="col">Identificador</th>
            <th scope="col">Operação</th>
            <th scope="col">Situação</th>
          </tr>
        </thead>
        <transition-group
          name="list"
          mode="in-out"
          tag="tbody"
          v-if="itensAbaAtual.length > 0"
        >
          <tr
            v-for="(item, itemIndex) in itensAbaAtual"
            :key="`item_${activeTab}_${itemIndex}`"
            :class="`categoria-${item.categoria}`"
          >
            <td class="text-center">
              <i v-if="item.categoria === 'erro'" class="icon-xis icon-erro" />
              <i
                v-else-if="item.categoria === 'alerta'"
                class="icon-warning icon-alerta"
              />
              <i
                v-else-if="item.categoria === 'aviso'"
                class="icon-info icon-aviso"
              />
              <i v-else class="icon-check icon-ok small" />
            </td>
            <td>
              {{ item.empresaOrigemNome || "-" }}<br />
              <span class="text-secondary">{{ item.cnpjOrigem || "-" }}</span>
            </td>
            <td>{{ item.identificadorSubDado || "-" }}</td>
            <td>
              <span
                class="badge-operacao"
                :class="item.isTransferencia ? 'transferir' : 'inativar'"
              >
                {{ item.isTransferencia ? "Transferir" : "Inativar" }}
              </span>
              <template v-if="item.isTransferencia">
                <br />
                <span class="text-secondary">
                  destino: {{ item.empresaDestinoNome || "-" }} ({{
                    item.cnpjDestino || "-"
                  }})
                </span>
              </template>
            </td>
            <td>
              <ul
                v-if="item.mensagens.length > 0"
                :class="['lista-situacao', item.categoria]"
              >
                <li v-for="(mensagem, mensagemIndex) in item.mensagens" :key="mensagemIndex">
                  {{ mensagem }}
                </li>
              </ul>
              <span v-else class="lista-situacao ok">Será processado</span>
            </td>
          </tr>
        </transition-group>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="5">
              Nenhum item nesta aba
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import PageTabs from "@/components/navigation/PageTabs.vue";

export default {
  props: {
    preview: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeTab: "CONTATOS",
    };
  },
  computed: {
    tabs() {
      return [
        {
          title: `Contatos (${this.preview.contatos.length})`,
          key: "CONTATOS",
          active: this.preview.contatos.length > 0,
        },
        {
          title: `Siglas CCEE (${this.preview.siglasCcee.length})`,
          key: "SIGLAS_CCEE",
          active: this.preview.siglasCcee.length > 0,
        },
        {
          title: `UCs (${this.preview.ucs.length})`,
          key: "UCS",
          active: this.preview.ucs.length > 0,
        },
      ];
    },
    itensAbaAtual() {
      if (this.activeTab === "SIGLAS_CCEE") return this.preview.siglasCcee;
      if (this.activeTab === "UCS") return this.preview.ucs;
      return this.preview.contatos;
    },
  },
  watch: {
    // Achado de revisão (IMPORTANTE): com `active` agora refletindo se a aba
    // tem itens, PageTabs ignora clique em aba `active: false` - sem isto o
    // usuário pode ficar preso em "CONTATOS" vazia quando a prévia só tem UCs.
    preview: {
      immediate: true,
      handler() {
        const primeiraAbaComItens = this.tabs.find((tab) => tab.active);
        this.activeTab = primeiraAbaComItens
          ? primeiraAbaComItens.key
          : "CONTATOS";
      },
    },
  },
  methods: {
    changeTab(key) {
      this.activeTab = key;
    },
  },
  components: {
    PageTabs,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/style.scss";
@import "@/assets/style/colors.scss";

th {
  font-weight: 500;
}

.categoria-erro {
  background-color: rgba($status--red, 0.12);
}

.categoria-alerta {
  background-color: rgba($status--yellow, 0.18);
}

.categoria-aviso {
  background-color: rgba($secondary--blue, 0.08);
}

.icon-erro {
  color: $status--red !important;
  &::before {
    color: $status--red !important;
  }
}

.icon-alerta {
  &::before {
    color: $status--yellow !important;
  }
}

.icon-ok {
  &::before {
    color: $status--green !important;
  }
}

.icon-aviso {
  &::before {
    color: $secondary--blue !important;
  }
}

.badge-operacao {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  color: $primary--white;
  &.inativar {
    background-color: $secondary--gray;
  }
  &.transferir {
    background-color: $secondary--blue;
  }
}

.lista-situacao {
  margin: 0;
  padding-left: 16px;
  font-size: 0.85rem;
  &.erro {
    color: $status--red;
  }
  &.alerta {
    color: #a67200;
  }
  &.aviso {
    color: $secondary--blue;
  }
  &.ok {
    color: $secondary--gray;
  }
}

.list-enter-active,
.list-leave-active {
  transition: opacity 0.3s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
}
</style>
